export default __webpack_public_path__ + "static/media/1.4e61a62e.svg";